var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.283 8.717c1.547 1.548 2.622.473 2.622.473l1.964 1.964a1.6 1.6 0 010 2.263L13.417 27.87a1.6 1.6 0 01-2.263 0l-1.963-1.964s1.074-1.075-.474-2.622c-1.547-1.548-2.622-.474-2.622-.474l-1.964-1.963a1.6 1.6 0 010-2.263L18.583 4.13a1.6 1.6 0 012.263 0l1.964 1.964s-1.075 1.075.473 2.622zm-12.17 16.714a3.174 3.174 0 01-.02.113l1.193 1.193 1.916-1.916-7.023-7.023-1.916 1.916 1.193 1.193.113-.02c1.06-.173 2.212.197 3.28 1.264 1.067 1.068 1.437 2.22 1.265 3.28zM8.31 16.667l7.023 7.023 11.404-11.404-1.192-1.193a3.323 3.323 0 01-.114.02c-1.06.173-2.212-.197-3.28-1.264-1.067-1.068-1.437-2.22-1.264-3.28l.02-.113-1.193-1.193L8.31 16.667zm3.755-.424l6.964-6.964 1.045 1.045-6.965 6.964-1.044-1.045zm9.402-4.527l-6.965 6.965 1.045 1.044 6.964-6.964-1.044-1.045z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.cee6beeacff35972fb29d8fa28f25059.svg";
export { ForwardRef as ReactComponent };